// extracted by mini-css-extract-plugin
module.exports = {"IRAFooter":"IRAFooterNew_IRAFooter__hSAU1"};